import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  max-width: 1366px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 20px;
  }

  span {
    color: #f16024;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1180px;
  width: 100%;
  margin: 100px auto 20px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 340px;
    margin: 24px auto 0;
  }

  p {
    text-align: left;
    font-family: 'Open Sans';
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;
    margin-bottom: 30px;

    span {
      color: #f16024;
    }
  }
`;

export const TextBox1 = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 80px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }

  p {
    margin-bottom: 10px;
  }

  span {
    color: #f16024;
  }
`;

export const TextBox2 = styled.div`
  flex: 1;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #c3c3c3;
  text-align: left;

  h2 {
    font-family: 'Barlow';
    width: 200px;
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
    color: #fcfcfc;

    @media (max-width: 768px) {
      font-size: 18px;
      font-style: normal;
      font-weight: 275;
      line-height: 24px;
      width: auto;
    }
  }

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      margin-top: 10px;
    }
  }
`;
